import { render, staticRenderFns } from "./extensionSmall.vue?vue&type=template&id=01c8b5bd"
import script from "./extensionSmall.vue?vue&type=script&lang=js"
export * from "./extensionSmall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports